import { Stack } from '@mui/material';
import { useToggleButtonGroup } from '@/components/shared/toggle-button-group/context';
import { StyledButton } from '@/components/shared/toggle-button-group/styles';
import { ToggleIcon } from '@/components/shared/toggle-button-group/components/icon';
import { type ToggleButtonProps } from '@/components/shared/toggle-button-group/interfaces';

export type { ToggleButtonProps };

export const ToggleButton = <T,>({
  value,
  children,
  disabled = false,
}: ToggleButtonProps<T>) => {
  const { value: groupValue, exclusive, onChange } = useToggleButtonGroup();

  const isSelected = exclusive
    ? groupValue === value
    : ((groupValue as T[]) || []).includes(value);

  const handleClick = () => {
    if (disabled) return;
    onChange(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <StyledButton
      role="button"
      aria-pressed={isSelected}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      isSelected={isSelected}
      isDisabled={disabled}
    >
      <ToggleIcon exclusive={exclusive} isSelected={isSelected} />
      <Stack flex={1}>{children}</Stack>
    </StyledButton>
  );
};
